import { NewProposalPage } from '@/features/proposals/components/new-proposal-page';
import { requirePermissions } from '@/shared/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/proposals/$id/')({
  component: RouteComponent,
  beforeLoad: async () => {
    const hasPermission = await requirePermissions(['policies.proposals.read']);
    if (!hasPermission) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

function RouteComponent() {
  const { id } = Route.useParams();
  return <NewProposalPage policyId={id} mode='view' />;
}
